import { CloseCircleOutlined, DownOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const ClearIcon = styled(CloseCircleOutlined)`
  &:hover {
    color: ${({ theme }) => theme.red};
  }
`;

export const SuffixIcon = styled(DownOutlined).attrs({
  className: 'ant-select-suffix',
})``;
